import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "38",
      height: "38",
      x: "1",
      y: "1",
      stroke: "currentColor",
      "stroke-width": "2",
      rx: "3"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.684",
      d: "M12.842 16.057h1.823m12.24 0h-1.693m-2.343 0v-3.215h-5.99v3.215m5.99 0h-5.99m5.99 0h2.343m-8.333 0h-2.214m0 0v10.848h10.547V16.057m-7.161 3.482 1.823 1.808m1.823 1.808-1.823-1.808m0 0 1.823-1.808-3.646 3.616"
    }, null, -1)
  ]))]))
}
export default { render: render }